define('main',['require','exports','module','appkit/app','!domReady','fukit/fukit','./auto.require'],function(require, exports, module) {
  var App = require('appkit/app');

  require('!domReady');

  new App({
    // set the app config
    config: require('fukit/fukit').config,
    loadModules: require('./auto.require'),
  }).start();
});

